import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  NonNullableFormBuilder,
  Validators
} from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { MatStepper } from '@angular/material/stepper';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import colorLib from '@kurkle/color';
import { Chart, ChartItem, ChartOptions } from 'chart.js';
import 'chartjs-adapter-moment';
import { default as annotation } from 'chartjs-plugin-annotation';
import * as moment from 'moment';
import { NzModalService } from 'ng-zorro-antd/modal';
import {
  BehaviorSubject,
  Subject,
  catchError,
  debounceTime,
  firstValueFrom,
  of,
  takeUntil
} from 'rxjs';
import { ProfileService } from 'src/app/_services/profile.service';
import { ProjectService } from 'src/app/_services/project.service';
import { ScrumService } from 'src/app/_services/scrum.service';
import Swal from 'sweetalert2';
import { BaseComponent } from '../../base/base.component';
import { ConcludiCollaborazioneComponent } from './concludi-collaborazione/concludi-collaborazione.component';

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY' // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'DD/MM/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

/* Charts */
Chart.register(annotation); //registro il plugin di annotation ai grafici
const CHART_COLORS = {
  light_orange: 'rgb(255, 178, 107)',
  blue: 'rgb(0, 51, 124)' /* Necessary */,
  orange: 'rgb(255, 123, 84)',
  light_blue: 'rgb(51, 102, 153)',
  dark_orange: 'rgb(204, 102, 0)',
  light_green: 'rgb(153, 204, 153)',
  purple: 'rgb(68, 50, 102)',
  yellow: 'rgb(255, 205, 86)' /* Necessary */,
  red: 'rgb(193, 49, 0)',
  green: 'rgb(65, 153, 69)' /* Necessary */
};

const PIE_CHART_COLORS = {
  1: '#FF6F61',
  2: '#FF9A00',
  3: '#F2C94C',
  4: '#D16666',
  5: '#56A3BF',
  6: '#3D7AA3',
  7: '#529E66',
  8: '#9A5FB5',
  9: '#6A4B8A',
  10: '#6B728E'
};

export interface RowData {
  name: string;
  age: number;
  country: string;
  // altre proprietÃ  delle righe
}
export interface Residue {
  id: number;
  sprint_id: number;
  pbi_code: number;
  original_effort: number;
  done_percentage: number;
  current_effort: number;
  completion_date: any;
  is_done: number;
  created_at: string;
  updated_at: string | null;
  deleted_at: string | null;
}

//interfaccia per modale assessment
interface AssessmentInput {
  modalInputRed: any;
  modalInputYellow: any;
  modalInputGreen: any;
  modalInputNone: any;
}

const assessmentInfo = [
  {
    id: 1,
    description:
      'Il mio carico di lavoro tipico mi consente di raggiungere un livello accettabile di equilibrio tra lavoro e vita privata. Cioè l’equilibro tra il lavoro e la mia vita privata è corretto oppure continuo a pensare sempre al problema che ho avuto a lavoro e ciò mi mette un senso di ansia e stress.'
  },
  {
    id: 2,
    description:
      'Strumenti/risorse/processi/procedure mi permettono di soddisfare efficacemente le esigenze dei miei clienti. Cioè gli strumenti, le risorse, i processi e le procedure applicate durante il lavoro mi permetto di essere efficiente così da portare a fine sempre il goal.'
  },
  {
    id: 3,
    description:
      'Mi sento al sicuro e non temo di commettere errori, di sollevare questioni spinose, di correre rischi o di chiedere aiuto. Cioè riesco a chiedere aiuto ai colleghi oppure sbatto per troppo tempo la testa su un problema non chiedendo aiuto; riesco ad avere un confronto costruttivo, anche se potrebbe essere una questione spinosa, con i colleghi o con il TL.'
  },
  {
    id: 4,
    description:
      'Capisco chiaramente cosa ci si aspetta da me in questo team. Cioè riesco a capire le descrizioni e le analisi effettuate su PBI o Task così da poter svolgere quest’ultimi in maniera corretta secondo quanto richiesto.'
  },
  {
    id: 5,
    description:
      'In questo ultimo sprint mi sono sentito entusiasta di lavorare ogni giorno. Cioè sono riuscito a dare il massimo ogni singolo giorno oppure sono stato più svogliato e quindi ho reso meno di quanto potevo.'
  },
  {
    id: 6,
    description:
      'Sono fiducioso che la nostra squadra avrà successo. Cioè credo che con il team riusciamo a raggiungere il goal che ci siamo prefissati andando a chiudere lo sprint e di conseguenza alla fine il progetto.'
  }
];

@Component({
  selector: 'app-scrum',
  templateUrl: './scrum.component.html',
  styleUrls: ['./scrum.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' }
  ]
})
export class ScrumComponent extends BaseComponent implements OnInit {
  destroy$ = new Subject<void>();
  dateNow = new Date();
  cerimonies: any[] = [];
  errorMessage: string | null = null;
  daily_time: number = 0;

  selectedSprintIndex: number;
  previousValues: { sfavorevole: number; neutrale: number; favorevole: number };

  bodyResidue: {
    sprint_id: number;
    residuePbi: Array<any>;
    deletedPBI: number[];
  } = {
    sprint_id: 0,
    residuePbi: [],
    deletedPBI: []
  };

  assessmentSelectedValue: any;

  private timeoutId: any;

  // TEST NUOVA MODALE ASSESSMENT
  dataTeamAssessment: any;
  dataTeamAssessmentEmpty = [
    {
      label: 'Work-life Balance',
      votes: [{ sfavorevole: 0, neutrale: 0, favorevole: 0, media: 0 }]
    },
    {
      label: 'Efficiency',
      votes: [{ sfavorevole: 0, neutrale: 0, favorevole: 0, media: 0 }]
    },
    {
      label: 'Clarity',
      votes: [{ sfavorevole: 0, neutrale: 0, favorevole: 0, media: 0 }]
    },
    {
      label: 'Energy',
      votes: [{ sfavorevole: 0, neutrale: 0, favorevole: 0, media: 0 }]
    },
    {
      label: 'Psychological Safety',
      votes: [{ sfavorevole: 0, neutrale: 0, favorevole: 0, media: 0 }]
    },
    {
      label: 'Confidence',
      votes: [{ sfavorevole: 0, neutrale: 0, favorevole: 0, media: 0 }]
    }
  ];

  select_people: any = [];
  last_sprint: any;
  filterSprint: number;
  last_sprint_end_date: any;
  buttonClicked: boolean = false;
  residuePbi: any = [];
  dataTotal: any; //totale effort residui
  sprint_id: any = '';
  sprint_num: any;
  teamcategory: any;
  project_route: string;
  project: any = null;
  typologies: any; //tutte le tipologie team disponibili
  sprint_data: any[] = [];
  billing_data: any;
  availableUsers$ = new BehaviorSubject<any[]>([]);
  selectedSprint: any;
  totalCapacity: any;
  currentDay = moment().format('YYYY-MM-DD');
  focusDay: any;
  modaLarge: any;
  is_authorized: boolean = false;
  currentIndex: number = -1;
  csvDataForm: FormGroup;
  showCsvStep: boolean;
  showResidueStep: boolean;
  selectedFileName: string;
  readyFile: any = '';
  insertSuccess: boolean = false;

  highlight: any | null = null;
  highlightedUser: number | null = null;
  firstKeyrow: any;
  secondKeyrow: any;
  thirdKeyrow: any;
  fourthKeyrow: any;
  fifthKeyrow: any;
  sixthKeyrow: any;
  isLoading: any = false;
  dayoffStatus = false;
  canSave = false;
  showModalTeamAssessment = false;
  lastSprintEndDate: Date;
  sprintNumberSelected: number;

  project_id: any;
  isScrum: boolean = false;
  sprints: any[]; /* = ['25', '26', '27']; */

  columnHeadersModal: string[] = [
    'Cod PBI',
    'Effort originale',
    '% Completamento',
    'Effort reale',
    'Data di completamento',
    'Azione'
  ];

  // altre intestazioni delle colonne, variabili dinamicamente
  statistic_type: any;
  // projectPic:any;

  /* modale sprint */
  isAddModal: boolean;
  generalData: FormGroup;
  capacityData: FormGroup | any;
  modalTypoImg: any;
  teamAssessmentForm: FormGroup;
  teamAssessmentFormHeader: FormGroup;

  /* multi date picker */
  isVisible: boolean = false;
  daysSelected: any[] = [];
  event: any;
  minDate: any;
  maxDate: any;
  @ViewChild('calendar') calendar: MatCalendar<any>;
  unavailableDates: any;

  // newRow:any;
  uniqueKeysrows: string[] = [];

  selectedChip: string = 'Team'; // Variabile per memorizzare la chip selezionata
  chipColors: { [key: string]: string } = {
    Team: 'yellow-chip',
    Interno: 'green-chip',
    Cliente: 'blue-chip'
    // Assegna ad ogni valore della chip un nome di classe o uno stile per il colore desiderato
  };

  Velocity: any = [];
  velocityForInternal: any;
  velocityForTeam: any;
  velocityForCustomer: any;

  // valore del team assessment
  teamAssessmentValue: any = [];
  private updateTimeout: any;
  private readonly cellValueChangeCapacityUsers = new Subject<{
    capacity_id: number;
    value: any;
    billing_value: number;
  }>();
  private readonly cellValueChangeCapacityStatistic = new Subject<{
    capacity_id: number;
    value: any;
  }>();

  // private cellValueChangeResidue = new Subject<{ row: any }>();
  residueForm: FormGroup;
  /* Evolution Chart */
  ctxEvol: ChartItem;
  evolChart: any;

  startDateGraph = '';
  endDateGraph = '';

  dataEvolChart: any = {
    labels: [],
    datasets: [
      {
        label: 'Velocity',
        backgroundColor: this.transparentize(CHART_COLORS.yellow, 0.7),
        borderColor: CHART_COLORS.yellow,
        fill: true,
        pointBackgroundColor: this.transparentize(CHART_COLORS.yellow, 0.2),
        pointRadius: 5,
        // stepped: true,
        // tension: 0.5,
        data: this.Velocity.Velocity,
        skipNull: true
      }
    ]
  };

  configEvolChart: any = {
    type: 'line',
    // plugins: [annotation],
    data: this.dataEvolChart,
    options: {
      aspectRatio: 1,
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        },
        title: {
          text: 'Andamento Sprint',
          display: true,
          font: {
            size: 18
          }
        },
        annotation: {
          annotations: []
        }
      },
      parsing: {
        xAxisKey: 'date',
        yAxisKey: 'value'
      },
      scales: {
        x: {
          type: 'timeseries',
          bounds: 'ticks',
          min: this.startDateGraph,
          max: this.endDateGraph,
          time: {
            unit: 'day',
            tooltipFormat: 'D-MM'
          },
          title: {
            display: false,
            text: 'Data'
          },
          ticks: {
            source: 'labels'
          },
          grid: {
            display: false
          }
        },
        y: {
          title: {
            display: true,
            text: 'Velocity'
          },
          beginAtZero: true,
          suggestedMax: 0.4
        }
      }
    } as ChartOptions
  };

  /* Capacity Chart */

  ctxCap: ChartItem;
  capChart: any;

  dataCapChart: any = {
    labels: [],
    datasets: [
      {
        label: 'Ore',
        backgroundColor: Object.values(PIE_CHART_COLORS),
        borderColor: '#f4f3ef',
        fill: true,
        data: []
      }
    ]
  };

  /* TORTA */
  configCapChart: any = {
    type: 'pie',
    data: this.dataCapChart,
    options: {
      aspectRatio: 1,
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'right'
        },
        title: {
          display: true,
          text: 'Ore totali membri del team',
          font: {
            size: 18
          }
        }
      }
    }
  };

  current_original_effort: number;
  current_effort_reale: number;

  velC: any;
  velI: any;
  velT: any;
  spC: any;
  spI: any;
  spT: any;

  showAssessment = false;

  isMobile: boolean;
  velocitaUltima: any[];
  lastDataSprint: any;
  current_day: any;
  lastVelocityCustomer: any;
  lastVelocityInternal: any;
  lastVelocityTeam: any;

  modalInputRed: number = 0;
  modalInputYellow: number = 0;
  modalInputGreen: number = 0;

  showGreenInput: boolean = false;

  valueChangeInput = true;

  totalDisable: number;

  isLess: boolean = false;

  //array per modale
  assessmentInputs: AssessmentInput[] = [
    {
      modalInputRed: 0,
      modalInputYellow: 0,
      modalInputGreen: 0,
      modalInputNone: 0
    }, // Work-life Balance
    {
      modalInputRed: 0,
      modalInputYellow: 0,
      modalInputGreen: 0,
      modalInputNone: 0
    }, // Efficiency
    {
      modalInputRed: 0,
      modalInputYellow: 0,
      modalInputGreen: 0,
      modalInputNone: 0
    }, // Psychological Safety
    {
      modalInputRed: 0,
      modalInputYellow: 0,
      modalInputGreen: 0,
      modalInputNone: 0
    }, // Clarity
    {
      modalInputRed: 0,
      modalInputYellow: 0,
      modalInputGreen: 0,
      modalInputNone: 0
    }, // Energy
    {
      modalInputRed: 0,
      modalInputYellow: 0,
      modalInputGreen: 0,
      modalInputNone: 0
    } // Confidence
  ];
  isBillingTable: BehaviorSubject<boolean> = new BehaviorSubject(false);
  loggedProfileData: any;
  userRole: any;

  constructor(
    private readonly scrumService: ScrumService,
    private readonly route: ActivatedRoute,
    private readonly fb: NonNullableFormBuilder,
    private readonly projectService: ProjectService,
    private readonly evolChartRef: ElementRef,
    private readonly capChartRef: ElementRef,
    private readonly title: Title,
    private readonly modalService: NzModalService,
    private readonly profileService: ProfileService,
    private readonly cdr: ChangeDetectorRef
  ) {
    super();
    this.selectedChip = 'Team';
    this.setProjectRoute();
    this._initSprintForm();
    this._initResidueForm();
    // this.projectPic = utilityService.getSanitizeUrl('image/projects/default.png')
    this.previousValues = { sfavorevole: 0, neutrale: 0, favorevole: 0 };
  }

  getSanitizeUrl(url: string) {
    this.utilityService.getSanitizeUrl(url);
  }

  selectChip(chip: string) {
    if (this.selectedChip === chip) {
      return; // Deseleziona la chip se Ã¨ giÃ  selezionata
    } else {
      this.selectedChip = chip; // Seleziona la chip cliccata
    }

    switch (chip) {
      case 'Interno':
        this.Velocity = this.velocityForInternal;
        /* Personalizzazione colori grafici */
        this.dataEvolChart.datasets[0].backgroundColor = this.transparentize(
          CHART_COLORS.yellow,
          0.7
        );
        this.dataEvolChart.datasets[0].pointBackgroundColor =
          this.transparentize(CHART_COLORS.yellow, 0.2);
        this.dataEvolChart.datasets[0].borderColor = CHART_COLORS.yellow;
        this.dataCapChart.datasets[0].backgroundColor =
          Object.values(PIE_CHART_COLORS);
        break;

      case 'Team':
        this.Velocity = this.velocityForTeam;
        this.dataEvolChart.datasets[0].backgroundColor = this.transparentize(
          CHART_COLORS.yellow,
          0.7
        );
        this.dataEvolChart.datasets[0].pointBackgroundColor =
          this.transparentize(CHART_COLORS.yellow, 0.2);
        this.dataEvolChart.datasets[0].borderColor = CHART_COLORS.yellow;
        this.dataCapChart.datasets[0].backgroundColor =
          Object.values(PIE_CHART_COLORS);
        break;

      case 'Cliente':
        this.Velocity = this.velocityForCustomer;
        this.dataEvolChart.datasets[0].backgroundColor = this.transparentize(
          CHART_COLORS.yellow,
          0.7
        );
        this.dataEvolChart.datasets[0].pointBackgroundColor =
          this.transparentize(CHART_COLORS.yellow, 0.2);
        this.dataEvolChart.datasets[0].borderColor = CHART_COLORS.yellow;
        this.dataCapChart.datasets[0].backgroundColor =
          Object.values(PIE_CHART_COLORS);
        break;

      default:
        break;
    }
    this.genEvolChart();
    this.genCapChart();

    // ottengo la chiave dell'oggetto
    this.fifthKeyrow = Object.keys(this.Velocity)[0];
    this.sixthKeyrow = Object.keys(this.Velocity)[1];
  }

  async ngOnInit() {
    this._initFormAssessmentHeader();

    this._initFormAssessmentContent();

    const screenWidth = window.innerWidth;

    if (screenWidth <= 567) {
      this.isMobile = true;
    } else if (screenWidth >= 567 && screenWidth <= 900) {
      this.isMobile = false;
    } else {
      this.isMobile = false;
    }
    //this.utilityService.setTitle("Tabella Scrum");

    // Aggiornamento
    this.selectedSprintIndex = this.sprint_id - 1; // Funzione da implementare per ottenere l'indice dello sprint corrente

    if (this.selectedSprintIndex <= 0) this.selectedSprintIndex = 0;
    else this.selectedSprintIndex - 1;

    // cambiamento dei valori degli input della capacity
    this.cellValueChangeCapacityUsers
      .pipe(
        debounceTime(750) // Ritarda di 100 millisecondi
      )
      .subscribe(({ capacity_id, value, billing_value }) => {
        this.isLoading = true;
        this.updateCapacitySprint(capacity_id, value, billing_value);
      });

    // cambiamento dei valori degli input della capacity
    this.cellValueChangeCapacityStatistic
      .pipe(
        debounceTime(750) // Ritarda di 100 millisecondi
      )
      .subscribe(({ capacity_id, value }) => {
        this.isLoading = true;
        this.updateCapacitySprintStatistic(capacity_id, value);
      });

    this.csvDataForm.get('isBilling')?.valueChanges.subscribe(isBilling => {
      if (isBilling) {
        this.csvDataForm.get('csvFile')?.disable();
        this.csvDataForm.get('isPilot')?.disable();
      } else {
        this.csvDataForm.get('csvFile')?.enable();
        this.csvDataForm.get('isPilot')?.enable();
      }
    });

    this.csvDataForm.get('isPilot')?.valueChanges.subscribe(isPilot => {
      if (isPilot) {
        this.csvDataForm.get('isBilling')?.disable();
      } else {
        this.csvDataForm.get('isBilling')?.enable();
      }
    });
    this.isBillingTable.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if (!this.project) return;
      if (value) {
        this.utilityService.setTitle('Fatturazione | ' + this.project.alias);
        this.title.setTitle('Fatturazione | Sviluppo Personale');
      } else {
        this.utilityService.setTitle('Scrum | ' + this.project.alias);
        this.title.setTitle('Scrum | Sviluppo Personale');
      }
    });
  }

  _initFormAssessmentHeader() {
    this.teamAssessmentFormHeader = this.fb.group({
      total: [null, Validators.required],
      voting: [null, Validators.required],
      feedback: [null, Validators.required],
      date: [null]
    });
  }

  _initFormAssessmentContent() {
    this.teamAssessmentForm = this.fb.group({
      assessments: this.fb.array([])
    });
  }

  async getAssessment(): Promise<void> {
    const r = await firstValueFrom(
      this.projectService.getAssessment(this.sprint_id)
    );
    this.dataTeamAssessment = r;
    r.forEach((element: any) => {
      if (element.assessmentcategory_id === 7) {
        this.teamAssessmentFormHeader.patchValue({ total: element.value });
      }
      if (element.assessmentcategory_id === 8) {
        this.teamAssessmentFormHeader.patchValue({ voting: element.value });
      }
      if (element.assessmentcategory_id === 9) {
        this.teamAssessmentFormHeader.patchValue({ feedback: element.value });
      }
      if (element.date) {
        this.teamAssessmentFormHeader.patchValue({
          date: new Date(element.date)
        });
      }
    });
    this.initForm();

    this.loggedProfileData = await this.profileService.getUserRoleAsync();
    this.userRole = this.loggedProfileData.roles[0].name;
  }

  initForm(): void {
    const control = <FormArray>this.teamAssessmentForm.controls['assessments'];

    control.clear();

    if (this.dataTeamAssessment.length > 0) {
      this.dataTeamAssessment?.forEach((item: any) => {
        if (
          item.assessmentcategory_id == 1 ||
          item.assessmentcategory_id == 2 ||
          item.assessmentcategory_id == 3 ||
          item.assessmentcategory_id == 4 ||
          item.assessmentcategory_id == 5 ||
          item.assessmentcategory_id == 6
        ) {
          const votesArray = this.fb.array([
            this.fb.group({
              sfavorevole: [
                item.unfavorite_percentage,
                [Validators.min(0), Validators.max(100), Validators.required]
              ],
              neutrale: [
                item.neutral_percentage,
                [Validators.min(0), Validators.max(100), Validators.required]
              ],
              favorevole: [
                item.favorite_percentage,
                [Validators.min(0), Validators.max(100), Validators.required]
              ],
              media: [
                item.value,
                [Validators.required, Validators.min(0), Validators.max(100)]
              ]
            })
          ]);

          const itemGroup = this.fb.group({
            label: [item.assessmentcategories.alias],
            info: assessmentInfo.find(
              assessment => assessment.id == item.assessmentcategory_id
            )?.description,
            votes: votesArray
          });

          control.push(itemGroup);
        }
      });
    } else {
      this.teamAssessmentFormHeader.patchValue({
        date: this.lastSprintEndDate
      });
      this.dataTeamAssessmentEmpty.forEach((item, index) => {
        const votesArray = this.fb.array(
          item.votes.map(() =>
            this.fb.group({
              sfavorevole: [
                null,
                [Validators.min(0), Validators.max(100), Validators.required]
              ],
              neutrale: [
                null,
                [Validators.min(0), Validators.max(100), Validators.required]
              ],
              favorevole: [
                null,
                [Validators.min(0), Validators.max(100), Validators.required]
              ],
              media: [
                null,
                [Validators.min(0), Validators.max(10), Validators.required]
              ]
            })
          )
        );
        const itemGroup = this.fb.group({
          label: [item.label],
          info: assessmentInfo[index].description,
          votes: votesArray
        });
        control.push(itemGroup);
      });
      this.showAssessment = true;
    }
  }

  get assessments(): FormArray {
    return this.teamAssessmentForm.get('assessments') as FormArray;
  }

  isAssessmentInvalid(i: number): boolean {
    const votesArray = this.votes(i); // Otteniamo il FormArray
    let total = 0;

    // Controlliamo la validità dei campi e calcoliamo la somma
    votesArray.controls.some(vote => {
      const sfavorevole = vote.get('sfavorevole')?.value || 0;
      const neutrale = vote.get('neutrale')?.value || 0;
      const favorevole = vote.get('favorevole')?.value || 0;

      total = sfavorevole + neutrale + favorevole;
    });

    // Restituisce true se è invalido o se la somma non è 100
    return total !== 100;
  }

  votes(index: number): FormArray {
    return this.assessments.at(index).get('votes') as FormArray;
  }

  manageAssessment(i: number, j: number) {
    clearTimeout(this.timeoutId);

    this.timeoutId = setTimeout(() => {
      const votesArray = this.votes(i);
      const voteGroup: any = votesArray.at(j);

      let sfavorevole = Number(voteGroup.get('sfavorevole').value) || 0;
      let neutrale = Number(voteGroup.get('neutrale').value) || 0;
      let favorevole = Number(voteGroup.get('favorevole').value) || 0;

      const values = { sfavorevole, neutrale, favorevole };
      const keys: Array<keyof typeof values> = [
        'sfavorevole',
        'neutrale',
        'favorevole'
      ];

      const nonEmptyKeys = keys.filter(
        key =>
          values[key] !== null && values[key] !== undefined && values[key] !== 0
      );
      const emptyKeys = keys.filter(
        key =>
          values[key] === null || values[key] === undefined || values[key] === 0
      );

      const total = nonEmptyKeys.reduce((acc, key) => acc + values[key], 0);

      if (total > 100) {
        // If the total exceeds 100, revert to previous values and show an alert
        voteGroup
          .get('sfavorevole')
          .setValue(this.previousValues.sfavorevole, { emitEvent: false });
        voteGroup
          .get('neutrale')
          .setValue(this.previousValues.neutrale, { emitEvent: false });
        voteGroup
          .get('favorevole')
          .setValue(this.previousValues.favorevole, { emitEvent: false });
        Swal.fire({
          title: 'Attenzione',
          text: 'La somma dei valori non può superare 100.',
          confirmButtonColor: '#00337C'
        });
      } else {
        // If the total is valid, save the current values as previous
        this.previousValues = { sfavorevole, neutrale, favorevole };
        if (total < 100) {
          this.isLess = true;
        } else if (total == 100) {
          this.isLess = false;
        }

        if (emptyKeys.length === 1 && total <= 100) {
          // If there is only one empty field and the sum of non-empty fields is <= 100, fill the empty field with the remaining value
          const remainingKey = emptyKeys[0];
          values[remainingKey] = Number((100 - total).toFixed(1));
          voteGroup
            .get('sfavorevole')
            .setValue(values.sfavorevole, { emitEvent: false });
          voteGroup
            .get('neutrale')
            .setValue(values.neutrale, { emitEvent: false });
          voteGroup
            .get('favorevole')
            .setValue(values.favorevole, { emitEvent: false });
          this.isLess = false;
        }
      }
    }, 900);
  }

  saveTeamAssessment() {
    // if (this.teamAssessmentForm.valid && this.teamAssessmentFormHeader.valid) {
    //   this.canSave = true;
    // }

    let data = {
      sprint_id: this.sprint_id,

      assessments: [
        {
          assessmentcategory_id: 4,
          unfavorite_percentage:
            this.teamAssessmentForm.value.assessments[0].votes[0].sfavorevole,
          favorite_percentage:
            this.teamAssessmentForm.value.assessments[0].votes[0].favorevole,
          neutral_percentage:
            this.teamAssessmentForm.value.assessments[0].votes[0].neutrale,
          value: this.teamAssessmentForm.value.assessments[0].votes[0].media
        },
        {
          assessmentcategory_id: 6,
          unfavorite_percentage:
            this.teamAssessmentForm.value.assessments[1].votes[0].sfavorevole,
          favorite_percentage:
            this.teamAssessmentForm.value.assessments[1].votes[0].favorevole,
          neutral_percentage:
            this.teamAssessmentForm.value.assessments[1].votes[0].neutrale,
          value: this.teamAssessmentForm.value.assessments[1].votes[0].media
        },
        {
          assessmentcategory_id: 1,
          unfavorite_percentage:
            this.teamAssessmentForm.value.assessments[2].votes[0].sfavorevole,
          favorite_percentage:
            this.teamAssessmentForm.value.assessments[2].votes[0].favorevole,
          neutral_percentage:
            this.teamAssessmentForm.value.assessments[2].votes[0].neutrale,
          value: this.teamAssessmentForm.value.assessments[2].votes[0].media
        },
        {
          assessmentcategory_id: 2,
          unfavorite_percentage:
            this.teamAssessmentForm.value.assessments[3].votes[0].sfavorevole,
          favorite_percentage:
            this.teamAssessmentForm.value.assessments[3].votes[0].favorevole,
          neutral_percentage:
            this.teamAssessmentForm.value.assessments[3].votes[0].neutrale,
          value: this.teamAssessmentForm.value.assessments[3].votes[0].media
        },
        {
          assessmentcategory_id: 3,
          unfavorite_percentage:
            this.teamAssessmentForm.value.assessments[4].votes[0].sfavorevole,
          favorite_percentage:
            this.teamAssessmentForm.value.assessments[4].votes[0].favorevole,
          neutral_percentage:
            this.teamAssessmentForm.value.assessments[4].votes[0].neutrale,
          value: this.teamAssessmentForm.value.assessments[4].votes[0].media
        },
        {
          assessmentcategory_id: 5,
          unfavorite_percentage:
            this.teamAssessmentForm.value.assessments[5].votes[0].sfavorevole,
          favorite_percentage:
            this.teamAssessmentForm.value.assessments[5].votes[0].favorevole,
          neutral_percentage:
            this.teamAssessmentForm.value.assessments[5].votes[0].neutrale,
          value: this.teamAssessmentForm.value.assessments[5].votes[0].media
        },
        {
          assessmentcategory_id: 7,
          value: this.teamAssessmentFormHeader.value.total
        },
        {
          assessmentcategory_id: 8,
          value: this.teamAssessmentFormHeader.value.voting
        },
        {
          assessmentcategory_id: 9,
          value: this.teamAssessmentFormHeader.value.feedback
        }
      ]
    };
    this.projectService.postTeamassessment(data).subscribe({
      next: (res: any) => {
        this.responseToast('success', res.message);
      },
      error: (err: any) => {
        this.responseToast('error', err.message);
      }
    });
  }

  selectPeople(start_date: any) {
    this.select_people = this.scrumService
      .selectPeople(this.project.id, start_date)
      .subscribe(result => {
        // Assegna il risultato alla variabile this.select_people
        this.select_people = result;
      });
  }

  onStartDateChange(date: Date) {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    this.selectPeople(formattedDate);
  }

  isin(id: string) {
    if (this.select_people.length > 0) {
      return this.select_people.includes(id);
    } else return true;
  }

  _initSprintForm() {
    this.daysSelected = [];
    this.modaLarge = false;
    this.isVisible = false;
    this.dataTotal = [];
    this.modalTypoImg = null;

    this.generalData = this.fb.group({
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
      days_off: [this.daysSelected],
      sprint_num: [Number, Validators.required]
    });

    this.capacityData = this.fb.group({
      team_category: ['', Validators.required],
      team_member: this.fb.array([]),
      daily_time: ['', Validators.required]
    });

    this.csvDataForm = this.fb.group({
      csvFile: [''],
      isPilot: [false],
      isBilling: [false]
    });

    this.availableUsers$.subscribe(users => {
      if (users && users.length > 0) {
        const teamMemberArray = this.capacityData.get(
          'team_member'
        ) as FormArray;
        teamMemberArray.clear(); // Cancella eventuali dati vecchi

        users.forEach(user => {
          const group = this.fb.group({
            user_id: [user.user_id, Validators.required],
            first_name: [user.first_name, Validators.required],
            last_name: [user.last_name, Validators.required],
            value: [user.value ?? 0, Validators.required],
            billing_value: [user.billing_value ?? 0, Validators.required]
          });

          group.get('value')?.valueChanges.subscribe(capacityValue => {
            let billingControl = group.get('billing_value');

            if (!billingControl) return;

            // Limitiamo il valore massimo e minimo
            if (parseFloat(capacityValue) > 8) {
              group.get('value')?.setValue(8, { emitEvent: false });
            } else if (parseFloat(capacityValue) < 0) {
              group.get('value')?.setValue(0, { emitEvent: false });
            }

            const billingValue = billingControl.value;

            // Se capacityValue è maggiore di billingValue, aggiorna billingValue
            if (
              billingValue != null &&
              billingValue !== '' &&
              parseFloat(capacityValue) > parseFloat(billingValue)
            ) {
              billingControl.setValue(capacityValue, { emitEvent: false });
            }

            billingControl.setValidators([
              Validators.min(parseFloat(capacityValue))
            ]);
            billingControl.updateValueAndValidity({ emitEvent: false });
          });

          group.get('billing_value')?.valueChanges.subscribe(billingValue => {
            let capacityControl = group.get('value');
            if (!capacityControl) return;

            // Limitiamo il valore massimo e minimo
            if (parseFloat(billingValue) > 8) {
              group.get('billing_value')?.setValue(8, { emitEvent: false });
            } else if (parseFloat(billingValue) < 0) {
              group.get('billing_value')?.setValue(0, { emitEvent: false });
            }

            const capacityValue = capacityControl.value;

            // Se billingValue è null o '', non aggiornare capacityValue per evitare di cancellarlo
            if (billingValue == null || billingValue === '') {
              return;
            }

            // Se billingValue è minore di capacityValue, aggiorna capacityValue
            if (parseFloat(billingValue) < parseFloat(capacityValue)) {
              capacityControl.setValue(billingValue, { emitEvent: false });
            }

            capacityControl.setValidators([
              Validators.max(parseFloat(billingValue))
            ]);
            capacityControl.updateValueAndValidity({ emitEvent: false });
          });

          // Aggiungi il gruppo al form array
          teamMemberArray.push(group);
        });
      }
    });

    if (this.sprints && this.sprint_id) {
      const sprint = this.sprints.find(
        (sprint: any) => sprint.id == this.sprint_id
      );

      this.capacityData.controls['team_category'].patchValue(
        sprint.teamcategory_id
      );

      if (!this.isAddModal) {
        this.generalData.controls['start_date'].patchValue(sprint.start_date);
        this.generalData.controls['end_date'].patchValue(sprint.end_date);
        this.generalData.controls['sprint_num'].patchValue(sprint.number);
        this.generalData.controls['sprint_num'].disable();

        this.daysSelected = sprint.daysoff;
        this.calendar.updateTodaysDate();
        this.changeTypoImg(this.teamcategory);
      } else if (this.isAddModal) {
        this.generalData.controls['sprint_num'].patchValue(
          this.getLastSprintNumber()
        );
      }
    }

    this.getProject();
  }

  filteredSprints(event?: any) {
    if (event) {
      this.filterSprint = event;
      if (!this.filterSprint) {
        return [...this.sprints].reverse();
      } else {
        return this.sprints.filter(
          sprint => sprint.number === this.filterSprint
        );
      }
    } else return [...this.sprints].reverse();
  }

  getLastSprintNumber(): number {
    // Controlla se ci sono sprints nella lista e restituisci il numero dell'ultimo sprint

    const lastSprintNumber =
      this.sprints.length > 0
        ? this.sprints[this.sprints.length - 1].number
        : null;
    return lastSprintNumber + 1;
  }

  /* Inizializzazione form residui */
  _initResidueForm() {
    this.residueForm = this.fb.group({
      residues: this.fb.array(this.loadResidue(this.residuePbi))
    });
  }

  get residueFormArray(): FormArray {
    return this.residueForm.controls['residues'] as FormArray;
  }

  private loadResidue(residues: Residue[]): FormGroup[] {
    return residues.map((item: Residue) => this.createResidueFormGroup(item));
  }

  private createResidueFormGroup(item: Residue): FormGroup {
    return new FormGroup({
      id: new FormControl(item.id),
      sprint_id: new FormControl(item.sprint_id, [Validators.required]),
      pbi_code: new FormControl(item.pbi_code, [Validators.required]),
      original_effort: new FormControl(item.original_effort, [
        Validators.required
      ]),
      done_percentage: new FormControl(item.done_percentage, [
        Validators.required
      ]),
      current_effort: new FormControl({
        value: item.current_effort,
        disabled: true
      }),
      is_done: new FormControl(
        item.completion_date ? item.completion_date : null
      ),
      created_at: new FormControl(item.created_at, [Validators.required]),
      updated_at: new FormControl(item.updated_at),
      deleted_at: new FormControl(item.deleted_at)
    });
  }

  clearDate(index: number) {
    const control = this.residueFormArray.at(index).get('is_done');
    if (control) {
      control.setValue(null);
      control.markAsDirty();
    }
  }

  /* Aggiunta riga tabella residui */
  addNewRow() {
    // this.newRow = {'sprint_id': this.sprint_id,'pbi_code'	: 0, 'original_effort': 0, 'done_percentage': 0, 'current_effort': '', 'is_done': false};
    // this.residuePbi.push(this.newRow);
    let newRow = new FormGroup({
      id: new FormControl(null),
      sprint_id: new FormControl(this.sprint_id, [Validators.required]),
      pbi_code: new FormControl('', [Validators.required]),
      original_effort: new FormControl(null, [Validators.required]),
      done_percentage: new FormControl(null, [Validators.required]),
      current_effort: new FormControl({ value: null, disabled: true }),
      is_done: new FormControl(null),
      created_at: new FormControl(null),
      updated_at: new FormControl(null),
      deleted_at: new FormControl(null)
    });
    this.residueFormArray.push(newRow);
  }

  /* Rimozione riga tabella residui */
  removeRow(residue_id: number) {
    this.scrumService.deleteResidue(residue_id, this.sprint_id).subscribe({
      next: () => {
        this.getInitializationData();
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: 'Residuo rimosso con successo',
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      },
      error: () => {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'error',
          iconColor: '#FFB26B',
          title: "Errore durante l'eliminazione",
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      }
    });
  }

  /* Calcoli totali tabella residui */
  calcTotal(type: string) {
    let sum = 0;
    if (type == 'done_percentage') {
      // CODICE PER CALCOLARE LA SOMMA DELLE PERCENTUALI
    } else {
      this.residueFormArray.value.forEach((pbi: any) => {
        sum += pbi[type];
      });
    }
    return sum;
  }

  /* Salvataggio residui in BE */
  saveResiduePbi() {
    this.bodyResidue.sprint_id = this.sprint_id;
    this.bodyResidue.residuePbi = this.residueFormArray.value || [];

    /* Controlli validazione numeri */
    this.bodyResidue.residuePbi?.forEach(function (residue: any) {
      if (residue.original_effort > 21) {
        residue.original_effort = 21;
      }
      if (residue.done_percentage > 100) {
        residue.done_percentage = 100;
      }
    });

    this.scrumService.saveResiduePbi(this.bodyResidue).subscribe({
      next: () => {
        this.getInitializationData();

        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: 'Residui aggiornati',
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      },
      error: err => {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'error',
          iconColor: '#FFB26B',
          title: err.err.message,
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      }
    });
  }

  changeTypo(typology_id: any) {
    this.scrumService
      .updateTeamCategory(this.sprint_id, typology_id)
      .subscribe({
        next: () => {
          this.getInitializationData();

          Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            icon: 'success',
            iconColor: '#FFB26B',
            title: 'Team category aggiornata',
            didOpen: toast => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
        }
      });
  }

  changeTypoImg(typo: any) {
    this.modalTypoImg = {
      color_code: typo.color_code,
      path: typo.filestorage.path
    };
  }

  // Versione precedente
  /*changeSprint(sprint: any) {
    this.sprint_id = sprint.id;
    this.getInitializationData();
  }*/

  changeSprint(sprint: any) {
    this.sprint_id = sprint.id;
    this.selectedSprintIndex = this.sprints.indexOf(sprint);
    this.getInitializationData();
    this.residuePbi = this.sprints[this.selectedSprintIndex];
  }

  selectPreviousSprint() {
    const filtered = this.sprints;
    if (filtered.length > 0) {
      this.currentIndex =
        (this.currentIndex - 1 + filtered.length) % filtered.length;
      this.selectedSprint = filtered[this.currentIndex];
      this.sprint_id = this.selectedSprint.id;
    }
    this.getInitializationData();
  }

  selectNextSprint() {
    const filtered = this.sprints;
    if (filtered.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % filtered.length;
      this.selectedSprint = filtered[this.currentIndex];
      this.sprint_id = this.selectedSprint.id;
    }
    this.getInitializationData();
  }

  // Funzione per verificare se il pulsante di sinistra deve essere disabilitato
  isLeftButtonDisabled(): boolean {
    return this.currentIndex === 0;
  }

  // Funzione per verificare se il pulsante di destra deve essere disabilitato
  isRightButtonDisabled(): boolean {
    return this.currentIndex === this.sprints.length - 1;
  }

  getChipColorClass(statistic_type: any): string {
    return this.chipColors[statistic_type];
  }

  // Aggiornamento
  getBadgeColorClass(chip: string): string {
    if (chip === 'Team') {
      return 'text-bg-light'; // Restituisce 'text-bg-danger' se il chip ÃƒÂ¨ 'Team'
    } else if (chip === 'Interno') {
      return 'text-bg-light'; // Restituisce 'text-bg-warning' se il chip ÃƒÂ¨ 'Interno'
    } else if (chip === 'Cliente') {
      return 'text-bg-light'; // Restituisce 'text-bg-primary' se il chip ÃƒÂ¨ 'Clienti'
    } else {
      return 'text-bg-secondary'; // Restituisce una stringa vuota per tutti gli altri chip
    }
  }

  saveSprint() {
    this.capacityData.value.team_member?.forEach(function (user: any) {
      if (user.value > 8) {
        user.value = 8;
      }
      if (user.billing_value > 8) {
        user.billing_value = 8;
      }
    });

    const daysoff: any[] = [];

    // pipe per rimandare le date in formato adatto al be
    this.daysSelected?.forEach(function (day: any) {
      const dataMoment = moment(day, 'DD-MM-YYYY');
      const dataFormattata = dataMoment.format('YYYY-MM-DD');

      day = dataFormattata;
      daysoff.push(day);
    });

    let sprint = {
      project_id: this.project.id,
      sprint_num: this.generalData.controls['sprint_num'].value,
      start_date: moment(this.generalData.controls['start_date'].value).format(
        'YYYY-MM-DD'
      ),
      end_date: moment(this.generalData.controls['end_date'].value).format(
        'YYYY-MM-DD'
      ),
      teamcategory_id: this.capacityData.controls['team_category'].value,
      dates: daysoff,
      capacities_per_day: this.capacityData.value.team_member,
      daily_time: this.capacityData.controls['daily_time'].value
    };

    if (this.isAddModal) {
      this.scrumService.createSprint(sprint).subscribe({
        next: (res: any) => {
          /* Reset modale */
          this._initSprintForm();
          this.sprint_id = res.result.id;

          this.getInitializationData();

          this.buttonClicked = false;
          this.showCsvStep = false;
          this.showResidueStep = false;
          this.daysSelected = [];

          Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            icon: 'success',
            iconColor: '#FFB26B',
            title: 'Sprint creato',
            didOpen: toast => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
        },
        error: (err: any) => {
          Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            icon: 'error',
            iconColor: '#FFB26B',
            title: err.error.message,
            didOpen: toast => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
        }
      });
    } else {
      this.scrumService.updateSprint(sprint, this.sprint_id).subscribe({
        next: (res: any) => {
          /* Reset modale */
          this._initSprintForm();
          this.sprint_id = res.result.id;
          this.daysSelected = [];
          this.showCsvStep = false;
          this.showResidueStep = true;

          Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            icon: 'success',
            iconColor: '#FFB26B',
            title: 'Sprint aggiornato',
            didOpen: toast => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
        },
        error: (err: any) => {
          Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            icon: 'error',
            iconColor: '#FFB26B',
            title: err.error.message,
            didOpen: toast => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
        }
      });
    }
  }

  concludeSprint() {
    this.scrumService.toggleConcludeSprint(this.sprint_id).subscribe({
      next: () => {
        this.isAddModal = true;
        this._initSprintForm();
        this._initResidueForm();
        this.getInitializationData();

        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: 'Sprint concluso',
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      },
      error: (err: any) => {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'error',
          iconColor: '#FFB26B',
          title: err.error.message,
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      }
    });
  }

  getInitializationData(calendar_start_date?: any, calendar_end_date?: any) {
    this.isLoading = false;
    if (this.sprint_id == 0) {
      this.sprint_id = undefined;
    }
    if (
      this.generalData.controls['start_date'].value != '' &&
      calendar_start_date == null
    )
      calendar_start_date = moment(
        this.generalData.controls['start_date'].value
      ).format('YYYY-MM-DD');
    if (
      this.generalData.controls['end_date'].value != '' &&
      calendar_end_date == null
    )
      calendar_end_date = moment(
        this.generalData.controls['end_date'].value
      ).format('YYYY-MM-DD');

    this.scrumService
      .indexCapacitySprint(
        this.project.id,
        this.sprint_id || '',
        calendar_start_date || null,
        calendar_end_date || null
      )
      .subscribe({
        next: (res: any) => {
          /* Inizializzazione tipologie team */
          this.isScrum = res.isScrum;
          this.typologies = res.team_category;
          this.cerimonies = res.cerimonies;
          this.daily_time = res.daily_time;
          this.sprintNumberSelected = res.sprint_selected;
          // ricaviamo la data di fine sprint che serve per la modale di team assessment
          const selectedSprint = res.sprints.find(
            (sprint: any) => sprint.number === this.sprintNumberSelected
          );
          this.lastSprintEndDate = new Date(selectedSprint.end_date);

          this.cerimonies.forEach(item => {
            if (item.billing_value === null) {
              item.billing_value = 0;
            }

            if (item.value === null) {
              item.value = 0;
            }
          });

          if (res.statistic_type) {
            this.velC = res.statistic_type.Cliente.Velocity;
            this.velI = res.statistic_type.Interno.Velocity;
            this.velT = res.statistic_type.Team.Velocity;
            this.spC = res.statistic_type.Cliente['SP Completati'];
            this.spI = res.statistic_type.Interno['SP Completati'];
            this.spT = res.statistic_type.Team['SP Completati'];
          }
          if (res.residue) {
            this.current_original_effort = res.residue.current_original_effort;
            this.current_effort_reale = res.residue.current_effort_reale;
          }

          if (res.last_sprint) {
            this.last_sprint = res.last_sprint;
            this.last_sprint_end_date = res.last_sprint.end_date;
          }

          this.typologies.forEach((typo: any) => {
            typo.filestorage.path = this.utilityService.getSanitizeUrl(
              typo.filestorage.path
            );
          });

          /* Inizializzazione sprint progetto */
          this.sprints = res.sprints;

          /* Controllo se sono presenti sprint */
          if (this.sprints.length != 0) {
            this.sprint_num = res.sprint_selected;
            // this.sprint_id = this.sprints.find((sprint: any) => sprint.number == this.sprint_num).id;

            this.selectedSprint = this.sprints.find(
              (sprint: any) => sprint.number == this.sprint_num
            );
            this.sprint_id = this.selectedSprint.id;

            this.teamcategory = this.selectedSprint.teamcategory;

            this.teamcategory.filestorage.path =
              this.utilityService.getSanitizeUrl(
                this.teamcategory.filestorage.path
              );
            this.startDateGraph = this.selectedSprint.start_date;
            this.endDateGraph = this.selectedSprint.end_date;

            /* Settaggio date non disponibili */
            this.unavailableDates = [];
            this.sprints.forEach(element => {
              this.unavailableDates = this.unavailableDates.concat(
                this.getDaysArray(
                  new Date(element.start_date),
                  new Date(element.end_date)
                )
              );
            });
          }

          this.dataTotal = res.residue?.total;

          if (this.sprint_id) {
            this.router.navigateByUrl(
              this.router.url.replace(
                this.route.snapshot.params['sprint_id'],
                this.sprint_id
              )
            );

            this.residuePbi = res.residue.result || [];

            this.focusDay = res.focused_day || this.currentDay;
            this.totalCapacity = res.total_capacity;
            this.statistic_type = Object.keys(res.statistic_type);

            this.velocityForInternal = res.statistic_type.Interno;
            this.velocityForTeam = res.statistic_type.Team;
            this.velocityForCustomer = res.statistic_type.Cliente;

            // Aggiornamento velocity
            this.lastVelocityCustomer =
              res.velocity_summary.Cliente.value ??
              res.velocity_summary.Cliente;
            this.lastVelocityTeam =
              res.velocity_summary.Team.value ?? res.velocity_summary.Team;
            this.lastVelocityInternal =
              res.velocity_summary.Interno.value ??
              res.velocity_summary.Interno;

            // Inizializza l'array nel costruttore
            this.velocitaUltima = [
              this.lastVelocityTeam,
              this.lastVelocityInternal,
              this.lastVelocityCustomer
            ];
            // End aggiornamento velocity

            // ottengo le chiavi dell'oggetto da usare nella tabella
            this.uniqueKeysrows = Object.keys(this.totalCapacity);

            this.firstKeyrow = Object.keys(this.totalCapacity)[0];
            this.secondKeyrow = Object.keys(this.totalCapacity)[1];
            this.thirdKeyrow = Object.keys(this.totalCapacity)[2];
            this.fourthKeyrow = Object.keys(this.totalCapacity)[3];

            this.Velocity = this.velocityForTeam;

            this.fifthKeyrow = Object.keys(this.Velocity)[0];
            this.sixthKeyrow = Object.keys(this.Velocity)[1];
          }
          this.availableUsers$.next(res.available_users);

          if (this.sprint_id) {
            this.sprint_data = [];
            res.users.forEach((element: any) => {
              if (element.is_capacity_per_days?.value != null) {
                this.sprint_data.push(element);
              }

              element.capacity.forEach((capacity: any) => {
                if (capacity.value == null) {
                  capacity.value = 0;
                }
              });
            });

            this.billing_data = res.billing_users_table;

            this.billing_data.forEach((element: any) => {
              element.capacity.forEach((capacity: any) => {
                capacity.billing_value == null
                  ? (capacity.billing_value = 0)
                  : capacity.billing_value;
              });
            });
          }

          this.currentIndex = this.sprints.findIndex(
            sprint => sprint.id === this.selectedSprint?.id
          );
          if (this.currentIndex === -1) {
            this.currentIndex = 0;
          }
          if (res.velocity_summary) {
            this.genEvolChart();
            this.genCapChart();
          }
          this.isLoading = false;

          this._initResidueForm();
        }
      });
  }

  genEvolChart() {
    this.evolChart ? this.evolChart.destroy() : '';

    /* Filtro dati, il punto non viene visualizzato se la data Ã¨ successiva a quella odierna */

    this.dataEvolChart.datasets[0].data = this.Velocity.Velocity.map(function (
      point: any
    ) {
      return new Date(point.date) >= new Date() ? null : point;
    });

    this.dataEvolChart.labels = this.Velocity.Velocity.map(function (
      point: any
    ) {
      return point.date;
    });

    /* Settaggio limiti dell'asse x */
    this.configEvolChart.options.scales.x.min = this.startDateGraph;
    this.configEvolChart.options.scales.x.max = this.endDateGraph;

    /* Aggiunta valori costanti per i vari tipi di team */
    this.configEvolChart.options.plugins.annotation.annotations = [];
    this.typologies.map((typo: any) => {
      let constant = {
        drawTime: 'afterDatasetsDraw',
        type: 'line',
        scaleID: 'y',
        value: typo.ideal_velocity,
        borderColor:
          typo.ideal_velocity == this.teamcategory.ideal_velocity
            ? typo.color_code
            : this.transparentize(typo.color_code, 0.8),
        borderWidth: 2,
        // borderDash: [5, 10],
        label: {
          drawTime: 'afterDatasetsDraw',
          display: false,
          backgroundColor: this.transparentize(typo.color_code, 0.6),
          borderRadius: 10,
          color: this.transparentize(typo.color_code, 0.2),
          font: {
            size: 12
          },
          content: typo.alias + ' (' + typo.ideal_velocity + ')',
          position: 'end'
        },
        enter({ element }: any) {
          element.label.options.display = true;
          return true; // force update
        },
        leave({ element }: any) {
          element.label.options.display = false;
          return true;
        }
      };

      this.configEvolChart.options.plugins.annotation.annotations.push(
        constant
      );
    });

    this.ctxEvol = this.evolChartRef.nativeElement.querySelector(`#evolChart`);
    this.evolChart = new Chart(this.ctxEvol, this.configEvolChart);
  }

  genCapChart() {
    this.capChart ? this.capChart.destroy() : '';

    // let chartCapData: { id: any; full_name: string; value: any; }[] = [];
    this.dataCapChart.datasets[0].data = [];
    this.dataCapChart.labels = [];
    this.sprint_data.map((user: any) => {
      /*       let userTotal = {
        id: user.id,
        full_name: user.first_name + ' ' + user.last_name,
        value: user.capacity.find((e: any) => e.is_total == true).value
      } */
      this.dataCapChart.datasets[0].data.push(
        user.capacity.find((e: any) => e.is_total == true).value
      );
      this.dataCapChart.labels.push(user.first_name + ' ' + user.last_name);
      // this.dataCapChart.datasets[0].data.push(userTotal);
    });

    if (this.dataCapChart.datasets[0].data.length == 1) {
      switch (this.selectedChip) {
        case 'Team':
          this.dataCapChart.datasets[0].borderColor =
            Object.values(PIE_CHART_COLORS);
          break;

        case 'Interno':
          this.dataCapChart.datasets[0].borderColor =
            Object.values(PIE_CHART_COLORS);
          break;

        case 'Cliente':
          this.dataCapChart.datasets[0].borderColor =
            Object.values(PIE_CHART_COLORS);
          break;
      }
    } else this.dataCapChart.datasets[0].borderColor = '#f4f3ef';
    /* Ordinamento dati dalla capacity piÃ¹ alta alla piÃ¹ bassa */
    /*     chartCapData.sort(function compareByCap(a: any, b: any) {
      return b.value - a.value;
    }) */

    // this.dataCapChart.datasets[0].data = chartCapData;

    this.ctxCap = this.capChartRef.nativeElement.querySelector(`#capChart`);
    this.capChart = new Chart(this.ctxCap, this.configCapChart);
  }

  cellValueChangedCapacityForUsers(
    capacity_id: number,
    value: number,
    billing_value: number
  ) {
    // Inviamo il valore al Subject per attivare il debouncing
    if (value != null) {
      this.cellValueChangeCapacityUsers.next({
        capacity_id,
        value,
        billing_value
      });
    }
  }

  cellValueChangedCapacityStatistic(capacity_id: number, value: number) {
    // Inviamo il valore al Subject per attivare il debouncing
    if (value != null) {
      this.cellValueChangeCapacityStatistic.next({ capacity_id, value });
    }
  }

  //
  cellValueChangedCapacityStatistic2(
    capacity_id: number,
    value: number,
    number: number
  ) {
    // Inviamo il valore al Subject per attivare il debouncing
    if (value != null) {
      if (value >= number) {
        value = number;
      }

      this.cellValueChangeCapacityStatistic.next({ capacity_id, value });
    }
  }

  updateCapacitySprint(
    capacity_id: number,
    value: number,
    billing_value: number
  ) {
    // Limita i valori
    value = Math.min(value, 8);
    billing_value = Math.min(billing_value, 8);

    // billing_value non può essere minore di value
    if (value > billing_value) {
      billing_value = value;
    }

    this.scrumService
      .updateCapacitySprint(
        {
          capacity_id: capacity_id,
          value: value,
          sprint_id: this.sprint_id,
          billing_value: billing_value
        },
        capacity_id
      )
      .pipe(
        catchError(err => {
          this.responseToast('error', err?.error?.message || err.message);

          // Continua il flusso invece di spezzarlo
          return of(null);
        })
      )
      .subscribe({
        next: res => {
          if (!res) return;

          // Gestione di warning non bloccante
          if (res.warning) {
            this.responseToast('warning', res.warning);
          } else {
            this.responseToast('success', res.message);
          }

          this.getInitializationData();
        }
      });
  }

  updateCapacitySprintStatistic(capacity_id: number, value: number) {
    this.scrumService
      .updateCapacitySprintStatistic(capacity_id, value, this.sprint_id)
      .subscribe({
        next: () => {
          this.getInitializationData();
          // this.isLoading = false;
        }
      });
  }

  getProject() {
    this.projectService.showProject(this.project_route).subscribe({
      next: (res: any) => {
        this.project_id = res.project.id;
        this.project = res.project;
        this.title.setTitle('Scrum | ' + res.project.alias);
        this.utilityService.setTitle('Scrum | ' + res.project.alias);
        this.project.filestorage.path = this.utilityService.getSanitizeUrl(
          this.project.filestorage.path
        );
        this.is_authorized = res.is_authorized;
        this.getInitializationData();
      }
    });
  }

  setProjectRoute() {
    this.project_route = this.route.snapshot.url[0].path;
    this.project_route = this.project_route.replace(/-/g, ' ');
    this.sprint_id = this.route.snapshot.params['sprint_id'] || null;

    // this.sprint_id = this.route.snapshot.paramMap.get('sprint_num');
  }

  // gestisce il cambiamento dei valori degli input all'interno della tabella di residui
  /*   cellValueChanged(row: any) {
    // Inviamo il valore al Subject per attivare il debouncing
    this.cellValueChangeResidue.next({ row });
  } */

  moveStepper(stepper: MatStepper, index: number) {
    setTimeout(() => {
      if (index >= 0 && index < stepper.steps.length) {
        stepper.selectedIndex = index;
      }
    });
  }

  /* MULTI DATEPICKER */
  isSelected = (event: any) => {
    const date =
      (event._i.date <= 9 ? '0' : '') +
      event._i.date +
      '-' +
      (event._i.month <= 9 ? '0' : '') +
      (event._i.month + 1) +
      '-' +
      event._i.year;

    return this.daysSelected.find(x => x == date) ? 'multi-selected' : '';
  };

  select(event: any, calendar: any, isChip: boolean) {
    let date: any;

    if (isChip == true) {
      date = event;
    } else {
      date =
        (event._i.date <= 9 ? '0' : '') +
        event._i.date +
        '-' +
        (event._i.month <= 9 ? '0' : '') +
        (event._i.month + 1) +
        '-' +
        event._i.year;
    }

    const index = this.daysSelected.findIndex(x => x == date);
    if (index < 0) this.daysSelected.push(date);
    else this.daysSelected.splice(index, 1);

    calendar.updateTodaysDate();
  }

  resetDaysOff(calendar: any) {
    if (
      moment(this.generalData.controls['end_date'].value).format(
        'YYYY-MM-DD'
      ) !== 'Invalid date'
    ) {
      this.getInitializationData(
        moment(this.generalData.controls['start_date'].value).format(
          'YYYY-MM-DD'
        ),
        moment(this.generalData.controls['end_date'].value).format('YYYY-MM-DD')
      );
    }
    this.daysSelected = [];
    calendar.updateTodaysDate();
  }

  goToMyteam() {
    let navigationExtras = {
      relativeTo: this.route
    };

    this.router.navigate(['i-miei-team'], navigationExtras);
  }

  /* Funzione per calcolare le date in un range di tempo */
  getDaysArray(start: any, end: any): any {
    for (
      var arr = [], dt = new Date(start);
      dt <= new Date(end);
      dt.setDate(dt.getDate() + 1)
    ) {
      // arr.push(new Date(dt));
      arr.push(moment(dt).format('YYYY-MM-DD'));
    }
    // this.unavailableDates = this.unavailableDates.concat(arr);
    return arr;
  }

  /* Flitro per il datepicker dello sprint per evitare la selezione di giorni non disponibili */
  datePickerFilter = (d: Date | null): boolean => {
    /* Nel caso in cui sia una modifica si permette di selezionare le date dello sprint */
    if (!this.isAddModal) {
      let filterDates = this.getDaysArray(
        this.selectedSprint.start_date,
        this.selectedSprint.end_date
      );
      this.unavailableDates = this.unavailableDates.filter(
        (el: any) => !filterDates.includes(el)
      );
    }

    if (this.unavailableDates) {
      const time = moment(d).format('YYYY-MM-DD');
      return !this.unavailableDates.find((x: any) => x == time);
    } else {
      return true;
    }
  };
  transparentize(value: any, opacity: any) {
    var alpha = opacity === undefined ? 0.5 : 1 - opacity;
    return colorLib(value).alpha(alpha).rgbString();
  }

  updateValues(source: string, assessment: AssessmentInput, i: any): void {
    let data;
    switch (i) {
      case 0:
        data = {
          unfavorite_percentage: assessment.modalInputRed,
          favorite_percentage: assessment.modalInputGreen,
          neutral_percentage: assessment.modalInputYellow,
          value: assessment.modalInputNone
        };
        this.teamAssessmentValue.push(data);
        break;

      case 1:
        data = {
          unfavorite_percentage: assessment.modalInputRed,
          favorite_percentage: assessment.modalInputGreen,
          neutral_percentage: assessment.modalInputYellow,
          value: assessment.modalInputNone
        };
        this.teamAssessmentValue.push(data);

        break;

      case 2:
        data = {
          unfavorite_percentage: assessment.modalInputRed,
          favorite_percentage: assessment.modalInputGreen,
          neutral_percentage: assessment.modalInputYellow,
          value: assessment.modalInputNone
        };
        this.teamAssessmentValue.push(data);

        break;

      case 3:
        data = {
          unfavorite_percentage: assessment.modalInputRed,
          favorite_percentage: assessment.modalInputGreen,
          neutral_percentage: assessment.modalInputYellow,
          value: assessment.modalInputNone
        };
        this.teamAssessmentValue.push(data);

        break;

      case 4:
        data = {
          unfavorite_percentage: assessment.modalInputRed,
          favorite_percentage: assessment.modalInputGreen,
          neutral_percentage: assessment.modalInputYellow,
          value: assessment.modalInputNone
        };
        this.teamAssessmentValue.push(data);

        break;

      case 5:
        data = {
          unfavorite_percentage: assessment.modalInputRed,
          favorite_percentage: assessment.modalInputGreen,
          neutral_percentage: assessment.modalInputYellow,
          value: assessment.modalInputNone
        };
        this.teamAssessmentValue.push(data);

        break;

      default:
        break;
    }

    if (source == 'red' && assessment.modalInputRed == '') {
      assessment.modalInputRed = 0;
    }

    if (source == 'yellow' && assessment.modalInputYellow == '') {
      assessment.modalInputYellow = 0;
    }

    if (source == 'green' && assessment.modalInputGreen == '') {
      assessment.modalInputGreen = 0;
    }

    const redInputPresent =
      typeof assessment.modalInputRed === 'number' &&
      !isNaN(assessment.modalInputRed);
    const yellowInputPresent =
      typeof assessment.modalInputYellow === 'number' &&
      !isNaN(assessment.modalInputYellow);
    const greenInputPresent =
      typeof assessment.modalInputGreen === 'number' &&
      !isNaN(assessment.modalInputGreen);

    const totalgreen =
      (redInputPresent ? assessment.modalInputRed : 0) +
      (yellowInputPresent ? assessment.modalInputYellow : 0);
    const totalred =
      (yellowInputPresent ? assessment.modalInputYellow : 0) +
      (greenInputPresent ? assessment.modalInputGreen : 0);
    const totalyellow =
      (greenInputPresent ? assessment.modalInputGreen : 0) +
      (redInputPresent ? assessment.modalInputRed : 0);

    const total =
      assessment.modalInputRed +
      assessment.modalInputYellow +
      assessment.modalInputGreen;

    const valuePresentRed = assessment.modalInputRed !== 0;
    const valuePresentYellow = assessment.modalInputYellow !== 0;
    const valuePresentGreen = assessment.modalInputGreen !== 0;

    this.totalDisable = total;

    {
      const remainingGreen = 100 - totalgreen;
      const remainingRed = 100 - totalred;
      const remainingYellow = 100 - totalyellow;

      switch (source) {
        case 'red':
          if (
            assessment.modalInputYellow == 0 &&
            assessment.modalInputGreen == 0
          ) {
            this.valueChangeInput = true;
          }
          if (total > 100) {
            assessment.modalInputRed = 100 - totalred;
          }
          if (valuePresentYellow && this.valueChangeInput == true) {
            assessment.modalInputGreen =
              remainingGreen > 0 ? remainingGreen : 0;
            this.valueChangeInput = false;
          }
          if (valuePresentGreen && this.valueChangeInput == true) {
            assessment.modalInputYellow =
              remainingYellow >= 0 ? remainingYellow : 0;
            this.valueChangeInput = false;
          }
          break;
        case 'yellow':
          if (
            assessment.modalInputRed == 0 &&
            assessment.modalInputGreen == 0
          ) {
            this.valueChangeInput = true;
          }
          if (total > 100) {
            assessment.modalInputYellow = 100 - totalyellow;
          }
          if (valuePresentRed && this.valueChangeInput == true) {
            assessment.modalInputGreen =
              remainingGreen > 0 ? remainingGreen : 0;
            this.valueChangeInput = false;
          }
          if (valuePresentGreen && this.valueChangeInput == true) {
            assessment.modalInputRed = remainingRed >= 0 ? remainingRed : 0;
            this.valueChangeInput = false;
          }
          break;
        case 'green':
          if (
            assessment.modalInputYellow == 0 &&
            assessment.modalInputRed == 0
          ) {
            this.valueChangeInput = true;
          }
          if (total > 100) {
            assessment.modalInputGreen = 100 - totalgreen;
          }
          if (valuePresentRed && this.valueChangeInput == true) {
            assessment.modalInputYellow =
              remainingYellow > 0 ? remainingYellow : 0;
            this.valueChangeInput = false;
          }
          if (valuePresentYellow && this.valueChangeInput == true) {
            assessment.modalInputRed = remainingRed >= 0 ? remainingRed : 0;
            this.valueChangeInput = false;
          }
          break;
        default:
          break;
      }
    }
  }

  onChangeType(source: string, assessment: AssessmentInput) {
    if (source == 'red' && assessment.modalInputRed == 0) {
      assessment.modalInputRed = '';
    }

    if (source == 'yellow' && assessment.modalInputYellow == 0) {
      assessment.modalInputYellow = '';
    }

    if (source == 'green' && assessment.modalInputGreen == 0) {
      assessment.modalInputGreen = '';
    }
  }

  //Funzioni per evindenziare le righe e le colonne al click su input
  highlightUser(userId: number) {
    this.highlightedUser = userId;
  }

  removeHighlight() {
    this.highlightedUser = null;
  }

  highlighted(row: any) {
    this.highlight = row;
  }

  removeHighlighted() {
    this.highlight = null;
  }

  // Funzione per controllare il valore massimo consentito per sp rimanenti
  getThirdKeyrowValue(): number {
    const thirdRow = this.totalCapacity[this.thirdKeyrow];
    return thirdRow
      ? thirdRow.reduce((acc: any, item: any) => acc + item.value, 0)
      : 0; // Modifica in base alla struttura di thirdKeyrow
  }

  //funzioni per modificare correttamente il valore delle celle nel caso di cancellazione totale del valore
  onInputKeyUp(capacity_id: number, value: number) {
    if (value == null) {
      value = 0;
      this.cellValueChangedCapacityStatistic(capacity_id, value); // reimposta a zero se l'input è vuoto
    }
  }

  onInputKeyUp2(capacity_id: number, value: number, number: number) {
    if (value == null) {
      value = 0;
      this.cellValueChangedCapacityStatistic2(capacity_id, value, number); // reimposta a zero se l'input è vuoto
    }
  }

  onFileSelected(event: any): void {
    let file = event.target.files[0];
    const fileInput = event.target;
    if (fileInput.files.length > 0) {
      this.selectedFileName = fileInput.files[0].name;
    } else {
      this.selectedFileName = '';
    }
    this.csvDataForm.value.file = file;
    this.readyFile = file;
  }

  insertCSV() {
    const formData = new FormData();

    formData.append('isPilot', this.csvDataForm.value.isPilot);
    formData.append('project_id', this.project_id);
    formData.append('sprint_id', this.route.snapshot.params['sprint_id']);
    formData.append('file', this.readyFile);

    // this.route.snapshot.params['sprint_id'] COMMENTO TEMPORANEO

    this.scrumService.insertData(formData).subscribe({
      next: (res: any) => {
        this._initSprintForm();

        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: res.message,
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
        this.insertSuccess = true;
      },
      error: (err: any) => {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          icon: 'error',
          iconColor: '#FFB26B',
          title: err.error.message,
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      }
    });
  }

  modalDocument(doc?: any) {
    if (!doc) {
      this.selectedFileName = '';
      this.csvDataForm.reset();
    }
  }

  onButtonClick() {
    this.buttonClicked = true; //mostro solamente residuo in stepper
    this.showResidueStep = true;
    this.isAddModal = false;
  }

  deleteUser(
    event: Event,
    project_user_id: number,
    start_date: any,
    end_date: any,
    user_name: string
  ) {
    if (!this.checkKeyEvent(event)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    let data = {
      project_user_id: project_user_id,
      start_date: start_date,
      end_date: end_date,
      user_name: user_name
    };

    const modalRef = this.modalService.create({
      nzContent: ConcludiCollaborazioneComponent,
      nzData: {
        data: data
      },
      nzFooter: null,
      nzMaskClosable: false,
      nzCentered: true,
      nzClosable: false,
      nzStyle: { borderRadius: '10px' }
    });

    modalRef.afterClose.subscribe(result => {
      if (result) {
        const previousValues = this.capacityData
          .get('team_member')
          ?.value.map(
            (control: { user_id: any; billing_value: any; value: any }) => ({
              user_id: control.user_id,
              billing_value: control.billing_value,
              value: control.value
            })
          );

        this.getInitializationData();

        this.availableUsers$.subscribe(availableUsers => {
          if (availableUsers && availableUsers.length > 0) {
            const capacityArray = this.capacityData.get(
              'team_member'
            ) as FormArray;
            capacityArray.clear();

            availableUsers.forEach(user => {
              const previousUser = previousValues.find(
                (prev: { user_id: any }) => prev.user_id === user.user_id
              );

              capacityArray.push(
                this.fb.group({
                  user_id: [user.user_id, Validators.required],
                  first_name: [user.first_name, Validators.required],
                  last_name: [user.last_name, Validators.required],
                  value: [
                    previousUser ? previousUser.value : user.value,
                    Validators.required
                  ],
                  billing_value: [
                    previousUser
                      ? previousUser.billing_value
                      : user.billing_value,
                    Validators.required
                  ]
                })
              );
            });
          }
        });
      }
    });
  }

  /**
   * Funzione toggle per cambiare la visualizzazione della tabella
   */
  toggleBilling() {
    this.isBillingTable.next(!this.isBillingTable.getValue());

    if (!this.isBillingTable.getValue()) {
      setTimeout(() => {
        this.genEvolChart();
        this.genCapChart();
      }, 0);
    } else {
      this.evolChart.destroy();
    }
  }

  getBillingSprint(event: number) {
    this.sprint_id = event;
    this.getInitializationData();
  }

  isUserHighlighted(user: any): boolean {
    if (!user.project_user?.length) return false;

    const today = new Date(); // Data attuale

    // Trova l'ultimo periodo terminato PRIMA di oggi (se esiste)
    const latestEndedPeriod = user.project_user
      .filter(
        (p: { endwork_date: string | number | Date }) =>
          p.endwork_date && new Date(p.endwork_date) < today
      )
      .reduce(
        (latest: string | null, p: { endwork_date: string | number | Date }) =>
          !latest || new Date(p.endwork_date) > new Date(latest)
            ? p.endwork_date
            : latest,
        null
      );

    // Controlla se l'utente ha attualmente un periodo lavorativo per quella sprint
    const isCurrentlyWorking = user.project_user.some(
      (p: {
        startwork_date: string | number | Date;
        endwork_date: string | number | Date;
      }) =>
        new Date(p.startwork_date) <= today &&
        (!p.endwork_date || new Date(p.endwork_date) >= today) // Se endwork_date è null, significa che è ancora in corso
    );

    // Evidenzia solo se l'utente HA terminato una collab ma NON ne ha attive attualmente
    return latestEndedPeriod !== null && !isCurrentlyWorking;
  }

  endWorkDate(user: any, date: string): boolean {
    if (!user.project_user?.length) return false; // Se non ha project_user, non bloccare nulla

    const dateToCheck = new Date(date);

    // Trova il periodo lavorativo più recente **prima della data corrente**
    const latestEndedPeriod = user.project_user
      .filter(
        (p: { endwork_date: string | number | Date }) =>
          p.endwork_date && new Date(p.endwork_date) <= dateToCheck
      )
      .reduce(
        (latest: string | null, p: { endwork_date: string | number | Date }) =>
          !latest || new Date(p.endwork_date) > new Date(latest)
            ? p.endwork_date
            : latest,
        null
      );

    // Trova il primo periodo lavorativo **dopo la data corrente**
    const nextStartPeriod = user.project_user
      .filter(
        (p: { startwork_date: string | number | Date }) =>
          new Date(p.startwork_date) > dateToCheck
      )
      .reduce(
        (
          earliest: string | null,
          p: { startwork_date: string | number | Date }
        ) =>
          !earliest || new Date(p.startwork_date) < new Date(earliest)
            ? p.startwork_date
            : earliest,
        null
      );

    // Controlla se l'utente ha un nuovo periodo attivo che inizia successivamente alla data corrente
    const hasFutureStart = user.project_user.some(
      (p: {
        startwork_date: string | number | Date;
        endwork_date: string | number | Date;
      }) =>
        new Date(p.startwork_date) <= dateToCheck &&
        (!p.endwork_date || new Date(p.endwork_date) >= dateToCheck)
    );

    // Se c'è un `startwork_date` futuro, blocca i giorni **prima** di questa data
    if (nextStartPeriod && dateToCheck < new Date(nextStartPeriod)) {
      return true;
    }

    // Disabilita le celle solo se **non** c'è un nuovo periodo attivo
    return latestEndedPeriod
      ? !hasFutureStart && dateToCheck > new Date(latestEndedPeriod)
      : false;
  }

  getEndWorkDate(user: any): string {
    if (!user.project_user || user.project_user.length === 0) return '';

    // Trova il `project_user` più recente (ordinato per `startwork_date`)
    const lastProjectUser = [...user.project_user].sort(
      (a, b) =>
        new Date(b.startwork_date).getTime() -
        new Date(a.startwork_date).getTime()
    )[0];

    // Se ha una `endwork_date`, la restituisce come tooltip
    return lastProjectUser?.endwork_date
      ? `Data fine collaborazione: ${new Date(
          lastProjectUser.endwork_date
        ).toLocaleDateString('it-IT')}`
      : '';
  }

  hasRestrictedRole(user: any): boolean {
    if (!user.project_user || user.project_user.length === 0) {
      return false;
    }

    // Trova il project_user attivo (senza endwork_date)
    const activeProjectUser = user.project_user.find(
      (pu: any) => pu.endwork_date === null
    );

    // Se esiste un ruolo attivo ed è 11, 12 o 13, allora disabilita la cella
    return activeProjectUser
      ? [11, 12, 13].includes(activeProjectUser.assignmentrole_id)
      : false;
  }

  correctInitialValues() {
    const teamMemberArray = this.capacityData.get('team_member') as FormArray;
    teamMemberArray.controls.forEach(control => {
      const billingControl = control.get('billing_value');
      const capacityControl = control.get('value');

      if (billingControl && capacityControl) {
        let billingValue = billingControl.value;
        let capacityValue = capacityControl.value;

        // **Limitiamo entrambi a 8**
        if (billingValue > 8) billingValue = 8;
        if (capacityValue > 8) capacityValue = 8;

        // **Capacity non può superare Billing**
        if (capacityValue > billingValue) {
          capacityValue = billingValue;
        }

        // Aggiorniamo i controlli senza eventi infiniti
        billingControl.setValue(billingValue, { emitEvent: false });
        capacityControl.setValue(capacityValue, { emitEvent: false });
      }
    });
    this.cdr.detectChanges();
  }

  /**
   * Funzione che serve per inviare 0.25 di ore allo scrum master se clicca nella checkbox
   *
   * @params day la data da mandare al BE per settare che in quel giorno si è fatto il daily o la typology passata
   * @params typology può essere `Daily | Planning | Sprint Review`
   */
  sendHoursToScrumMaster = (day: any, typology: string) => {
    const today = new Date().toISOString().split('T')[0];
    const selectedDate = day?.date ? day.date : today;

    this.scrumService
      .toggleDaily(this.sprint_id, selectedDate, typology)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.getInitializationData();
        },
        error: error => {
          this.responseToast('error', error);
        }
      });
  };

  updateUserCapacity = (
    day: any,
    typology: string,
    billing_value?: number,
    test?: any
  ) => {
    clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(() => {
      const today = new Date().toISOString().split('T')[0];
      const selectedDate = day?.date ? day.date : today;

      this.scrumService
        .updateUserCapacity(
          this.sprint_id,
          selectedDate,
          typology,
          billing_value,
          test ? 1 : 0
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.getInitializationData();
            this.errorMessage = null;
          },
          error: err => (this.errorMessage = err.error.message)
        });
    }, 1000);
  };

  /**
   * Funzione per comparare le date in modo da disabilitare le checkbox con le date future rispetto a oggi
   */
  compareDate = (date: Date) => {
    const dateSprint = new Date(date);

    return dateSprint >= this.dateNow;
  };

  /**
   * funzione che serve per controllare se inseiriamo una media maggiore rispetto al 10, se inseriamo un valore superiore inserisce 10 automaticamente, altrimeti inserisci
   * quello che l'utente ha dato in input.
   * @param form form che stiamo controllando
   * @param i indice dell'array dei voti
   * @param j indice dell'array dei controls
   */
  onInputAssement(form: any, i: number, j: number) {
    if (form.media > 10) {
      this.votes(i).controls[j].patchValue({
        media: 10
      });
    }
  }

  /**
   * Funzione per fare il replace se la stringa in input inizia con 0
   */
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;

    // Se inizia con '0' e non è seguito da un punto o virgola, rimuovi solo lo zero iniziale
    if (
      input.value.startsWith('0') &&
      input.value.length > 1 &&
      !/^[0][.,]/.test(input.value)
    ) {
      input.value = input.value.replace(/^0+/, '');
    }
  }

  getImagePath(name: string): string {
    const images: { [key: string]: string } = {
      Estimate: 'assets/images/estimate.png',
      Planning: 'assets/images/planning.png',
      'Sprint Review': 'assets/images/sprint_review.png'
    };
    return images[name];
  }

  setHasCSV() {
    this.projectService
      .setHasCsv(this.sprint_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.responseToast('success', res.message);
          this.csvDataForm.reset();
        },
        error: (err: any) => {
          this.responseToast('error', err.error.error);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
